let Backbone = require("backbone");

let main = function(Backbone){
    return Backbone.Model.extend({});
};

let exportedValue = main(Backbone);
module.exports = exportedValue;


// WEBPACK FOOTER //
// ./src/model/OverviewModel.js